  
  import {MenuItemInterface} from "../interface/MenuItemInterface"

  const menuItems : MenuItemInterface[] = [
    {
      label: "home",
      icon: 'pi-home',
      url: "/home",
      permission: "HOME",
      hasDivider: false
    },
    {
      label: "consumo",
      icon: 'pi-chart-bar',
      url: "/consumo",
      permission: "CONSUMO",
      hasDivider: false
    },
    {
      label: "consultaCredito",
      icon: 'pi-search',
      url: "/consultar",
      permission: "CONSULTAR",
      hasDivider: false
    },
    {
      label: "negativacao",
      icon: 'pi-id-card',
      url: "/registro",
      permission: "REGISTRO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "historicoConsulta",
      icon: ' pi-history',
      url: "/historico",
      permission: "CONSULTA_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "arquivoRegistro",
      icon: 'pi-folder',
      url: "/arquivoregistro",
      permission: "ARQUIVOREGISTRO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "relatorioConsulta",
      icon: ' pi-filter',
      url: "/filtrarconsultasintetica",
      permission: "RELATORIO_CONSULTA_SINTETICA",
      hasDivider: false
    },
    {
      label: "relatorioApuracaoBilhete",
      icon: ' pi-filter',
      url: "/filtrarapuracaobilhete",
      permission: "RELATORIO_APURACAO_BILHETE",
      hasDivider: false
    },
    {
      label: "faturamento",
      icon: 'pi-wallet',
      url: "/faturamento",
      permission: "FATURAMENTO_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "fatura",
      icon: 'pi-dollar',
      url: "/fatura",
      permission: "FATURA_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "servico",
      icon: 'pi-server',
      url: "/servico",
      permission: "SERVICO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "plano",
      icon: 'pi-briefcase',
      url: "/plano",
      permission: "PLANO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "usuario",
      icon: 'pi-users',
      url: "/usuario",
      permission: "USUARIO_VISUALIZAR",
      hasDivider: true
    },
    {
      label: "franquia",
      icon: "pi-building",
      url: "/franquia",
      permission: "FRANQUIA_VISUALIZAR",
      hasDivider: false,
    },
    {
      label: "cliente",
      icon: 'pi-tag',
      url: "/cliente",
      permission: "CLIENTE_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "notificacao",
      icon: "pi-megaphone",
      url: "/notificacao",
      permission: "NOTIFICACAO_VISUALIZAR",
      hasDivider: false,
    },
    {
      label: "campanha",
      icon: 'pi-gift',
      url: "/campanha",
      permission: "CAMPANHA_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "permissao",
      icon: 'pi-code',
      url: "/permissao",
      permission: "PERMISSAO_VISUALIZAR",
      hasDivider: false
    },
    {
      label: "parametrosAplicacao",
      icon: 'pi-cog',
      url: "/parametros",
      permission: "PARAMETRO_VISUALIZAR",
      hasDivider: false
    }
    
  ];
 
  export default menuItems;
  